import { Validator } from '../../../types/common/form';
import { countString } from '../countCharacters';

//antd 글자수 계산로직이 이모지를 제대로 카운트 하지 못해서 validator로 검증
export const validateStringLength = ({
  min,
  max,
  message,
}: {
  min?: number;
  max?: number;
  message: string;
}): Validator<string | undefined> => {
  return (rule, value, callback) => {
    const length = value ? countString(value.trimStart()) : 0;

    if (min && length < min) return callback(message);
    if (max && length > max) return callback(message);

    callback();
  };
};
